import {observable, action, computed } from "mobx";
import { getUniqueSortedLabelValuePairsFromObjects } from "../components/modules/utils";

class CommonStore {
    @observable liftgateList = [{label: "L", value: true}];
    @observable routeTypeList = [{label: "City", value: false}, {label:"Trap", value: true}];
    @observable terminalList = [{label: "TPA", value: 1, terminalCode: "TPA"}];
    @observable trailersData =[];
    @observable anchorPointData = {terminalCode: null, anchorPointList: []};
    @observable filteredAnchorPointsOnMap = [];
    @observable isOptimizationRunning=false;
    @observable parametersData = [];
    @observable wavesData = [];
    @observable parametersDataLoaded = false;
    @observable wavesDataLoaded = false;
    @observable lockOptionsList = [
        { label: "Unlock", value: 0},
        { label: "Partial-lock", value: 1},
        { label: "Lock", value:2}
    ];
    @observable twoManList = [{label: "Y", value: true}];
    @observable cargoVanEligibleList = [{label: "Y", value: true}];

    @action updateAnchorPointsData(anchorPointList, terminalCode){
        this.anchorPointData= {
            anchorPointList,
            terminalCode
        };
        this.updateFilteredAnchorPoints(anchorPointList);
    }

    @action updateFilteredAnchorPoints(filteredData){
        if(filteredData){
            this.filteredAnchorPointsOnMap.replace(filteredData);
        }else{
            this.filteredAnchorPointsOnMap.replace(this.anchorPointData.anchorPointList || []);
        }
    }

    @action updateTrailersData(trailersList){
        this.trailersData.replace(trailersList)
    }

    @action updateParametersData(parametersData){
        this.parametersData.replace(parametersData);
        this.parametersDataLoaded = true;
    }

    @action setParametersDataLoaded(loaded){
        this.parametersDataLoaded = loaded;
    }

    @action updateIsOptimizationRunningFlag(flag){
        this.isOptimizationRunning=flag;
    }

    @action updateWaveData(wavesList){
        this.wavesData.replace(wavesList);
        this.wavesDataLoaded = true;
    }

    @action setWavesDataLoaded(loaded){
        this.wavesDataLoaded = loaded;
    }

    @computed get anchorPointList(){
        return this.anchorPointData.anchorPointList.filter(anchorPoint => anchorPoint.isSelected).map(anchor => ({label: anchor.anchorPointName , value: anchor.anchorPointName}));
    }

    @computed get maxWaitingTimeAtStop() {
        return this.parametersData.find(
            (param) => param.parameterName === "MaxWaitingTimeAtStop"
          )?.defaultValue || "0";
    }

    @computed get weeklyAllowedHOS() {
        return (
          this.parametersData.find(
            (param) => param.parameterName === "WeeklyAllowedHOS"
          )?.defaultValue ?? "0"
        );
    }

    @computed get dailyAllowedHOS() {
        return (
          this.parametersData.find(
            (param) => param.parameterName === "DailyAllowedHOS"
          )?.defaultValue ?? "0"
        );
    }

    @computed get trailersList(){
        return this.availableTrailers.map(trailer => ({label: trailer.trailerName , value: trailer.trailerId}));
    }

    @computed get equipmentSizes(){
        return getUniqueSortedLabelValuePairsFromObjects(this.trailersData, 'trailerLength');
    }

    @computed get availableTrailers(){
        return this.trailersData.filter(trailer => trailer.totalCount > 0);
    }

    @computed get trailerInfo(){
        return this.availableTrailers.reduce((acc, trailer) => {
            acc[trailer.trailerName] = trailer;
            return acc;
        }, {});
    }

    @action.bound getTrailerInfo(trailerName){
        if(!trailerName) return null;
        return this.trailerInfo[trailerName] || null;
    }
}

export default new CommonStore;